/* eslint-disable no-unused-vars */
import { Calendar, Checkbox } from 'antd'
import dayjs from 'dayjs'
import { Dispatch, SetStateAction, forwardRef, useMemo, useState, useEffect } from 'react'
import { LEARNING_MODE } from '../../../constants'
import FlagIcon from '../../../iconsV2/FlagIcon'
import { ICourse, IFilter } from '../../../types'
import styles from '../SAPPCalendarFilter.module.css'
import TestIcon from 'src/iconsV2/TestIcon'
import CaseStudyIcon from 'src/iconsV2/CaseStudyIcon'
import Button from '../common/Button'

interface IProps {
  filter: IFilter
  setFilter: Dispatch<SetStateAction<IFilter>>
  courses?: ICourse[]
  onRefetchAPI: (filterDate: Date) => void
}

const FilterCalendar = forwardRef<HTMLDivElement, IProps>(({
  filter,
  setFilter,
  courses,
  onRefetchAPI
}, ref) => {
  // Temporary filter state for UI
  const [tempFilter, setTempFilter] = useState<IFilter>(filter)

  // Update temp filter when prop filter changes
  useEffect(() => {
    setTempFilter(filter)
  }, [filter])


  const noteFilter = useMemo(
    () => [
      {
        title: 'Online',
        icon: <div className={styles['calendar-filter_note_blue']} />,
        value: LEARNING_MODE.ONLINE
      },
      {
        title: 'Live Online',
        icon: <div className={styles['calendar-filter_note_pureple']} />,
        value: LEARNING_MODE.LIVE_ONLINE
      },
      {
        title: 'Offline',
        icon: <div className={styles['calendar-filter_note_green']} />,
        value: LEARNING_MODE.OFFLINE
      },
      {
        title: 'Holiday',
        icon: <div className={styles['calendar-filter_note_yellow']} />,
        value: LEARNING_MODE.HOLIDAY
      },
      {
        title: 'Overdue',
        icon: <div className={styles['calendar-filter_note_red']} />,
        value: LEARNING_MODE.OVERDUE
      },
      { title: 'Test', icon: <TestIcon />, value: LEARNING_MODE.TEST },
      {
        title: 'Case Study',
        icon: <CaseStudyIcon />,
        value: LEARNING_MODE.CASE_STUDY
      },
      {
        title: 'Key Content Before',
        icon: <FlagIcon />,
        value: LEARNING_MODE.KEY_BEFORE_CONTENT
      },
    ],
    []
  )

  const handleTempFilter = (type: string, value: string) => {
    switch (type) {
      case 'course': {
        setTempFilter((prev: IFilter) => {
          const courseId = prev.courseId || []
          const updatedCourseId = courseId.includes(value)
            ? courseId.filter((item) => item !== value)
            : [...courseId, value]
          return { ...prev, courseId: updatedCourseId }
        })
        break
      }
      case 'note': {
        setTempFilter((prev: IFilter) => {
          const typeArray = prev.type || []
          const updatedType = typeArray.includes(value)
            ? typeArray.filter((item) => item !== value)
            : [...typeArray, value]
          return { ...prev, type: updatedType }
        })
        break
      }
      case 'day': {
        setTempFilter((prev: IFilter) => {
          return { ...prev, day: value }
        })
        break
      }
    }
  }

  const handleConfirm = () => {
    // Apply the temporary filter to the actual filter
    setFilter({...tempFilter, isOpen: false})
    // If there's a day filter, also trigger the API refetch
    if (tempFilter.day) {
      onRefetchAPI(dayjs(tempFilter.day).toDate())
    }
  }

  // const handleFilterday = (date: Dayjs) => {
  //   setTempFilter((prev) => ({ ...prev, day: date.toString() }))
  //   onRefetchAPI(date.toDate())
  // }

  return (
    <div ref={ref} className={styles['calendar-filter']}>
      <div className={styles['calendar-filter_title']}>
        Sort Filter
      </div>
      <div className={styles['calendar-filter_container_list_item']}>
        {noteFilter.map((item) => {
          return (
            <div
              className={styles['calendar-filter_content_list_item']}
              key={item.value}
            >
              <div
                onClick={() => handleTempFilter('note', item.value)}
                className={styles['calendar-filter_content_item_eye']}
              >
                 <Checkbox className={styles['custom-checkbox']} checked={tempFilter.type?.includes(item.value)}/>
              </div>
              <div className={styles['calendar-filter_content_list_item']}>
                {item.icon}
                {item.title}
              </div>
            </div>
          )
        })}
      </div>
      <div className={styles["calendar-filter__container-button"]}>
        <Button color='primary' onClick={handleConfirm}> Confirm</Button>
      </div>
    </div>
  )
})

export default FilterCalendar
